<template>
  <div class="shadow bg-white flex flex-col flex-1 min-w-max">
    <div class="flex items-center p-3">
      <span
        :class="[
          'p-2 text-3xl rounded',
          icon.color === 'red-light' ? `bg-red-light` : `bg-${icon.color}`,
        ]"
        ><base-icon :icon="icon.name" class="text-white"
      /></span>
      <div v-if="loading" class="linear-background ml-4 h-6 w-2/3"></div>
      <div v-else class="flex flex-col ml-4 mr-3">
        <div class="flex items-end">
          <span class="text-xl font-bold leading-tight">{{ amount.volume }}</span>
          <div
            :class="[
              'hidden items-center ml-2 font-semibold',
              amount.increase ? 'text-green' : 'text-red',
            ]"
          >
            <base-icon :icon="amount.increase ? 'arrow-up' : 'arrow-down'" />
            <span class="">{{ amount.delta }}</span>
          </div>
        </div>
        <span class="opacity-75 font-semibold tracking-tight" v-html="totalText"></span>
      </div>
      <div v-if="link" class="min-w-max ml-auto mr-2">
        <base-link :name="link" :query="query" class="no-underline flex flex-col">
          <base-icon icon="arrow-right" class="text-2xl" />
          <span class="text-xs">{{ viewAll }}</span>
        </base-link>
      </div>
    </div>
  </div>
</template>

<script>
import {BaseIcon, BaseLink} from '@/components/base'

export default {
  components: {
    BaseIcon,
    BaseLink,
  },

  props: {
    icon: {
      type: Object,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    amount: {
      type: Object,
      required: true,
    },
    link: {
      type: String,
      required: false,
    },
    query: {
      type: Object,
      required: false,
    },
    loading: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      totalText: this.$t(`mygwf.components.User.OverviewCard.${this.label}`),
      viewAll: this.$t(`mygwf.components.User.OverviewCard.view_all`),
    }
  },
}
</script>
<style scoped>
@keyframes placeHolderShimmer {
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: 200px 0;
  }
}
.linear-background {
  @apply bg-red-200;

  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: linear-gradient(to right, #edf2f7 8%, #f6f7f8 18%, #edf2f7 33%);
  background-size: 500px 10px;
  position: relative;
  overflow: hidden;
}
</style>
